import { LANGUAGE_REGISTRY } from "~/lib/language-lens";

// Shared by first paint and client navigation, including localized entry URLs.
const LIGHT_THEME_ROUTES = new RegExp(
  `^/(?:(?:${Object.keys(LANGUAGE_REGISTRY).join("|")})/)?(?:start|onboarding-v1-preview)/?$`,
  "i",
);

export function getForcedRouteTheme(pathname: string): "light" | undefined {
  return LIGHT_THEME_ROUTES.test(pathname) ? "light" : undefined;
}

/** Runs before paint without changing the user's stored theme preference. */
export const THEME_BOOTSTRAP_SCRIPT = `try {
  var root = document.documentElement;
  var forcedLight = ${LIGHT_THEME_ROUTES}.test(location.pathname);
  var t = localStorage.getItem("glider:webapp-v2:theme");
  var dark = !forcedLight && (t === "dark" || (t !== "light" && matchMedia("(prefers-color-scheme: dark)").matches));
  root.classList.remove("light", "dark");
  root.classList.add(dark ? "dark" : "light");
  root.style.colorScheme = dark ? "dark" : "light";
} catch {}`;
